import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import OpencareLogoSvg from 'pages/common/components/svgs/OpencareLogoSvg';
import {
  DIMENSIONS,
  useWindowDimensions,
} from 'providers/WindowDimensionsProvider';

import { CheckoutTimer } from './CheckoutTimer/CheckoutTimer';
import {
  LogoWrapper,
  NavbarContainer,
  NavbarContent,
} from './Navbar-styled-components';
import { SecureBadge } from './SecureBadge/SecureBadge';

const LOGO_HEIGHT = '30px';

export const Navbar = () => {
  const { layout } = useWindowDimensions();
  const isMobile = layout === DIMENSIONS.MOBILE;
  const showLogoText = !isMobile;

  const { clinicId } = useParams<{ clinicId: string; }>();

  const clinicUrl = useMemo(() => {
    return `/results/${clinicId || ''}`;
  }, [clinicId]);

  return (
    <NavbarContainer>
      <NavbarContent>
        <LogoWrapper aria-label="Return to practice profile" to={clinicUrl}>
          <OpencareLogoSvg
            hideContainer
            height={LOGO_HEIGHT}
            withText={showLogoText}
            color={BRAND_COLORS.darkGray}
          />
        </LogoWrapper>

        <CheckoutTimer />

        <SecureBadge />
      </NavbarContent>
    </NavbarContainer>
  );
};
